import {EmailSignUpValues} from "./SignUpWithEmailForm";
import {createUserWithEmailAndPassword, updateProfile} from "@firebase/auth";
import {auth} from "../../firebase/firebase-config";
import {toAccountsError} from "../../firebase/errors";

export type SignUpResult = {
  uid: string
}

export const signUpWithEmailAndPassword = async (values: EmailSignUpValues): Promise<SignUpResult> => {
  const res = await createUserWithEmailAndPassword(auth, values.email, values.password)
  .catch((err) => Promise.reject(toAccountsError(err, "signupError")));
  await updateProfile(res.user, {displayName: values.name})
      .catch(err => console.error("error setting displayName for user, ignoring", err));
  return {uid: res.user.uid};
};